<template>
  <van-tabbar v-model="active" :z-index="9" route>
    <van-tabbar-item
      v-for="(item, index) in tabbars"
      :key="index"
      :to="{ path: item.url, query: route.query }"
      :class="{ 'active-item': index === active }"
      replace
      @click="goToWy(index)"
    >
      <template #icon>
        <GlobalImage v-show="index === active" fit="contain" :src="item.active" class="tab-icon" />
        <GlobalImage v-show="index !== active" fit="contain" :src="item.normal" class="tab-icon" />
      </template>
      <span v-show="index > 0 || active > 0">{{ item.title }}</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup>
import { ref, onBeforeMount, reactive, watch } from 'vue-demi'
import { getImageUrl, isHideShowComment } from '@/utils'
import { store } from '@/pinia/store'
import { useRoute } from 'vue-router'

const route = useRoute()
const storeData = store()
const active = ref(0)
const tabbars = reactive([
  {
    title: '首页',
    normal: getImageUrl('homePage', 'tab_icon_01.png'),
    active: getImageUrl('homePage', 'tab_icon_01_act.png'),
    url: '/index',
  },
  {
    title: '技师',
    normal: getImageUrl('homePage', 'tab_icon_02.png'),
    active: getImageUrl('homePage', 'tab_icon_02_act.png'),
    url: '/technicianModule/technicianList/index',
  },
  {
    title: '发现',
    normal: getImageUrl('homePage', 'tab_icon_03.png'),
    active: getImageUrl('homePage', 'tab_icon_03_act.png'),
    url: '/trendsModule/trends/index',
  },
  {
    title: '订单',
    normal: getImageUrl('homePage', 'tab_icon_04.png'),
    active: getImageUrl('homePage', 'tab_icon_04_act.png'),
    url: '/orderModule/myOrders/index',
  },
  {
    title: '我的',
    normal: getImageUrl('homePage', 'tab_icon_05.png'),
    active: getImageUrl('homePage', 'tab_icon_05_act.png'),
    url: '/myModule/home/index',
  },
])

watch(
    () => route.path,
    (n) => {
      const index = tabbars.findIndex(x => x.url === n)
      if (index > -1) {
        active.value = index
      }
    }
)

onBeforeMount(() => {
  if (isHideShowComment()) {
    tabbars.splice(2, 1)
  }
  const currentIndex = tabbars.findIndex(item => route.path.startsWith(item.url))
  if (currentIndex !== -1) {
    active.value = currentIndex
  }
})

const goToWy = () => {
  storeData.isFirstVisitHome = true
  if (active.value == 1) {
    storeData.umengOrder.origin = '技师列表'
  } else if (active.value == 2) {
    storeData.umengOrder.origin = '发现'
  } else if (active.value == 3) {
    storeData.umengOrder.origin = '我的订单'
  } else if (active.value == 4) {
    storeData.umengOrder.origin = '我的页面'
  }
}
</script>


<style lang="scss">
.van-tabbar {
  height: 52px;
  .van-tabbar-item {
    padding: 6px 0 9px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    .van-tabbar-item__icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0;
      .tab-icon {
        width: 20px;
        height: 20px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .van-tabbar-item__text {
      font-size: 10px;
      color: #1F1F1F;
      span {
        line-height: 1;
      }
    }
    &:first-of-type {
      &.active-item {
        .van-tabbar-item__icon {
          width: 40px;
          height: 40px;
          .tab-icon {
            width: 40px;
            height: 40px;
            img {
              width: 40px;
              height: 40px;
            }
          }
        }
      }
    }
    &.active-item {
      .van-tabbar-item__text {
        color: $colorYellow;
      }
    }
  }
}
</style>